module.exports = __webpack_public_path__ + "img/yy.11dfd01c.png";